// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

// project imports
import useConfig from '@/theme/useConfig';
import { MenuOrientation } from '@/theme/config';
import DrawerHeader from '@/layout/Dashboard/Drawer/DrawerHeader';
import { useNeighborhoodModeration } from '@/providers/auth';
import Profile from './Profile';
import Notification from './Notification';
import Chat from './Chat';
import FullScreen from './FullScreen';
import ThemeModeToggle from './ThemeModeToggle';
import DevErrorLogButton from './DevErrorLogButton';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { state } = useConfig();
  const { isModerator } = useNeighborhoodModeration();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {state.menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open />}
      <Box sx={{ width: 1, ml: 1 }} />

      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75 }}>
        <DevErrorLogButton />
        <ThemeModeToggle />
        {/* moderatorul de cartier nu are chatul general — doar conversația cartierului lui */}
        {!isModerator && <Notification />}
        {!isModerator && <Chat />}
        {!downLG && <FullScreen />}
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Stack>
    </>
  );
}
